<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div class="example-inner">
  <kendo-tabstrip>
    <kendo-tabstrip-tab title="Creams Daily Comparison" [selected]="true">
      <ng-template kendoTabContent>
        <div style="background-color: lightcyan;">
          <span><strong>Daily Comparison General</strong></span>
          <kendo-grid
            [data]="gridDataCurrentDay"
            [height]="125"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="false"
            [sortable]="false"
            [size]="smallSize"
          >
            <kendo-grid-column field="year" title="Year"></kendo-grid-column>
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <kendo-grid-column field="date" title="Date"></kendo-grid-column>
            <kendo-grid-column field="dayOfWeek" title="Day"></kendo-grid-column>
            <kendo-grid-column field="netSales" title="Net" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>         
            <kendo-grid-column field="totalSales" title="Total Dine-In" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ (dataItem.cashSales + dataItem.cardSales) + dataItem.multipleSales | number : '1.2-2' }}</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Dine-In %" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ ((dataItem.cashSales + dataItem.cardSales) + dataItem.multipleSales) / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery %" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.deliverySales / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="transactions" title="Transactions" [sortable]="false" [style]="{'text-align': 'right'}">
            </kendo-grid-column>
          </kendo-grid>
        </div>
        <br/>
        <div class="demo-container">
          <div style="width:50%;">
            <strong>Dine-In Sales </strong>
          </div>
          <div style="width:50%;">
            <strong>Delivery Sales</strong>
          </div>
        </div>
        <div class="demo-container">
        <div class="demo-dense-grid">
          <kendo-grid
            [data]="gridDataCurrentDay"
            [height]="125"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="false"
            [sortable]="false"
            [style.maxHeight.px]="390"
          [size]="smallSize"
          >
            <kendo-grid-column field="year" title="Year"></kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ (dataItem.cashSales + dataItem.cardSales) + dataItem.multipleSales | number : '1.2-2' }}</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="Cash" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="%" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.cashSales / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="cardSales" title="Card" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="c" title="%" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.cardSales / dataItem.totalSales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="multipleSales" title="Multiple" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            
          </kendo-grid>
        </div>
        <div class="demo-dense-grid">
          <kendo-grid
            [data]="gridDataCurrentDay"
            [height]="125"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="false"
            [sortable]="false"
            [size]="smallSize"
          >
            <kendo-grid-column field="year" title="Year"></kendo-grid-column>
            <kendo-grid-column field="deliverySales" title=" Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="%" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.deliverooSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="%t" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.justEatSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="%" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.uberEatsSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Creams Monthly Comparison">
      <ng-template kendoTabContent>
        
         <br/>
        
        <div style="background-color: lightcyan;">
          <span>Monthly Comparison</span>
          <kendo-grid
            [data]="gridDataCurrentMonth"
            [height]="125"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="false"
            [sortable]="false"
            [size]="smallSize"
          >
            <kendo-grid-column field="year" title="Year"></kendo-grid-column>
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="netSales" title="Net" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="Cash" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="cardSales" title="Card" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.deliverooSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.justEatSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.uberEatsSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="multipleSales" title="Multiple" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="transactions" title="Transactions" [sortable]="false" [style]="{'text-align': 'right'}">
            </kendo-grid-column>
          </kendo-grid>
        </div>
        <br/>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Creams Yearly Comparison">
      <ng-template kendoTabContent>
        
        <div style="background-color: lightcyan;">
          <span>Yearly Comparison</span>
          <kendo-grid
            [data]="gridDataCurrentYear"
            [height]="125"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="false"
            [sortable]="false"
            [size]="smallSize"
          >
            <kendo-grid-column field="year" title="Year"></kendo-grid-column>
            <kendo-grid-column field="totalSales" title="Total" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="netSales" title="Net" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="Cash" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="cardSales" title="Card" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.deliverooSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.justEatSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats" [sortable]="false" format="##,###.##">
              <ng-template
                kendoGridCellTemplate
                let-dataItem
              >
              <strong>{{ dataItem.uberEatsSales / dataItem.deliverySales * 100 | number : '1.2-2' }} %</strong>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="multipleSales" title="Multiple" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
            </kendo-grid-column>
            <kendo-grid-column field="transactions" title="Transactions" [sortable]="false" [style]="{'text-align': 'right'}">
            </kendo-grid-column>
          </kendo-grid>
        </div>
        <br/>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Creams Yearly Sales">
      <ng-template kendoTabContent>
        <div>
          <kendo-grid
            [data]="gridData"
            [height]="650"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            (dataStateChange)="dataStateChange($event)"
            [sortable]="true"
            [size]="smallSize"
          >
            <kendo-grid-column field="year" title="Year"></kendo-grid-column>
            <!--<kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <kendo-grid-column field="date" title="Date" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column> -->
            <kendo-grid-column field="totalSales" title="Total Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
                <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                    <span style='float: right'>
                      {{ total["totalSales"].sum.toFixed(2) | currency:'GBP' }}
                    </span>
                  </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="netSales" title="Net Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["netSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="Cash Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["cashSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cardSales" title="Card Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["cardSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["deliverySales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["deliverooSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["justEatSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["uberEatsSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="multipleSales" title="Multiple Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["multipleSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <!--<kendo-grid-command-column title="Actions" [width]="220">
              <ng-template kendoGridCellTemplate>
                <button kendoGridEditCommand [primary]="true">Edit</button>
                <button kendoGridRemoveCommand>Delete</button>
              </ng-template>
            </kendo-grid-command-column>-->
          </kendo-grid>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Creams Year & Month Sales">
      <ng-template kendoTabContent>
        <div>
          <kendo-grid
            [data]="gridDataYearMonth"
            [height]="650"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            (dataStateChange)="dataStateChange($event)"
            [sortable]="true"
            [size]="smallSize"
          >
            <kendo-grid-column field="year" title="Year"></kendo-grid-column>
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <!--<kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <kendo-grid-column field="date" title="Date" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column> -->
            <kendo-grid-column field="totalSales" title="Total Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
                <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                    <span style='float: right'>
                      {{ totalYearMonth["totalSales"].sum.toFixed(2) | currency:'GBP' }}
                    </span>
                  </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="netSales" title="Net Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["netSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="Cash Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["cashSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cardSales" title="Card Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["cardSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["deliverySales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["deliverooSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["justEatSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["uberEatsSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="multipleSales" title="Multiple Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalYearMonth["multipleSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <!--<kendo-grid-command-column title="Actions" [width]="220">
              <ng-template kendoGridCellTemplate>
                <button kendoGridEditCommand [primary]="true">Edit</button>
                <button kendoGridRemoveCommand>Delete</button>
              </ng-template>
            </kendo-grid-command-column>-->
          </kendo-grid>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Creams Monthly Sales">
      <ng-template kendoTabContent>
        <div>
          <kendo-grid
            [data]="gridDataMonth"
            [height]="650"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            (dataStateChange)="dataStateChange($event)"
            [sortable]="true"
            [size]="smallSize"
          >
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <!--<kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <kendo-grid-column field="date" title="Date" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column> -->
            <kendo-grid-column field="totalSales" title="Total Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
                <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                    <span style='float: right'>
                      {{ totalMonth["totalSales"].sum.toFixed(2) | currency:'GBP' }}
                    </span>
                  </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="netSales" title="Net Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalMonth["netSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="Cash Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["cashSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cardSales" title="Card Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["cardSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalMonth["deliverySales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalMonth["deliverooSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalMonth["justEatSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalMonth["uberEatsSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="multipleSales" title="Multiple Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalMonth["multipleSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <!--<kendo-grid-command-column title="Actions" [width]="220">
              <ng-template kendoGridCellTemplate>
                <button kendoGridEditCommand [primary]="true">Edit</button>
                <button kendoGridRemoveCommand>Delete</button>
              </ng-template>
            </kendo-grid-command-column>-->
          </kendo-grid>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Creams Day of Week Sales">
      <ng-template kendoTabContent>
        <div>
          <kendo-grid
            [data]="gridDataDayOfWeek"
            [height]="650"
            [pageSize]="gridState.take"
            [skip]="gridState.skip"
            [pageable]="true"
            (dataStateChange)="dataStateChange($event)"
            [sortable]="true"
            [size]="smallSize"
          >
            <kendo-grid-column field="dayOfWeek" title="Day"></kendo-grid-column>
            <!--<kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="month" title="Month"></kendo-grid-column>
            <kendo-grid-column field="date" title="Date" [sortable]="false"></kendo-grid-column>
            <kendo-grid-column field="paymentMonth" title="paymentMonth" [sortable]="false"></kendo-grid-column> -->
            <kendo-grid-column field="totalSales" title="Total Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
                <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                    <span style='float: right'>
                      {{ totalDayOfWeek["totalSales"].sum.toFixed(2) | currency:'GBP' }}
                    </span>
                  </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="netSales" title="Net Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalDayOfWeek["netSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cashSales" title="Cash Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["cashSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="cardSales" title="Card Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ total["cardSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverySales" title="Delivery Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalDayOfWeek["deliverySales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="deliverooSales" title="Deliveroo Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalDayOfWeek["deliverooSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="justEatSales" title="JustEat Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalDayOfWeek["justEatSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="uberEatsSales" title="UberEats Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalDayOfWeek["uberEatsSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <kendo-grid-column field="multipleSales" title="Multiple Sales" [sortable]="false" [style]="{'text-align': 'right'}" format="£##,###.##">
              <ng-template kendoGridFooterTemplate> <!-- let-aggregates="aggregates">-->
                <span style='float: right'>
                  {{ totalDayOfWeek["multipleSales"].sum.toFixed(2) | currency:'GBP' }}
                </span>
              </ng-template> 
            </kendo-grid-column>
            <!--<kendo-grid-command-column title="Actions" [width]="220">
              <ng-template kendoGridCellTemplate>
                <button kendoGridEditCommand [primary]="true">Edit</button>
                <button kendoGridRemoveCommand>Delete</button>
              </ng-template>
            </kendo-grid-command-column>-->
          </kendo-grid>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
  
</div>
